import { render, staticRenderFns } from "./ITRValuableCloneableCard.vue?vue&type=template&id=4cf5b311&scoped=true&"
import script from "./ITRValuableCloneableCard.vue?vue&type=script&lang=ts&"
export * from "./ITRValuableCloneableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5b311",
  null
  
)

export default component.exports